import dayjs from 'dayjs'
import i18n from '@/i18n'
import { TranslateResult } from 'vue-i18n'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

// targetTime までの残り時間を表現する文字列を i18n 翻訳結果として返す
// 1日以上なら「d日」、1時間以上なら「h時間」、それ未満なら「m分」
export function getDurationString(
  targetTime: string,
  currentTime?: string
): string | TranslateResult {
  const target = dayjs(targetTime)
  const now = currentTime ? dayjs(currentTime) : dayjs()

  const day = target.diff(now, 'day')
  if (day >= 1) {
    return i18n.t('durationFormatDay', { day })
  }

  const hour = target.diff(now, 'hour')
  if (hour >= 1) {
    return i18n.t('durationFormatHour', { hour })
  }

  const min = Math.max(0, target.diff(now, 'minute'))
  return i18n.t('durationFormatMin', { min })
}

export function formatTime(targetTime: string, format: string): string {
  return dayjs(targetTime).format(format)
}

// タイムゾーン対応でLocation名("Asia/Tokyo", "America/Chicago"など)を取得する
export function getLocationName(): string {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  return dayjs.tz.guess()
}

export function formatEventPeriod(startAt: string, endAt: string): string {
  if (!startAt || !endAt) {
    return ''
  }

  const start = dayjs(startAt)
  const end = dayjs(endAt)

  // 年が違う場合
  if (start.year() !== end.year()) {
    // 年月日で表示
    return `${start.format('YYYY/MM/DD HH:mm')} 〜 ${end.format(
      'YYYY/MM/DD HH:mm'
    )}`
  }

  // 年が同じで月か日が違う場合
  if (start.month() !== end.month() || start.date() !== end.date()) {
    // 月日で表示
    return `${start.format('YYYY/MM/DD HH:mm')} 〜 ${end.format('MM/DD HH:mm')}`
  }

  // 同じ日であれば時分で表示
  return `${start.format('YYYY/MM/DD HH:mm')} 〜 ${end.format('HH:mm')}`
}
